import { Fragment, useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import { Divider, Typography } from '@mui/material';

import { OptionService } from 'services';
import { usePermissions, useService } from 'hooks';
import { PageTitle, Layout, Spinner } from 'components';
import optionTypes from 'common/constants/optionTypes';
import { PERMISSIONS } from 'common/constants/permissions';

import './Options.scss';
import OptionsForm from './OptionsForm';
import QualificationCriteria from './QualificationCriteria';
import TaskTypes from './TaskTypes';
import UserListOptions from './UserListOptions';
import UserRates from './UserRates';

const { getOptions, updateOptions } = OptionService;
const { CONFIG_GENERAL, CONFIG_LISTS, CONFIG_QUALIFICATION, CONFIG_TASK_TYPES, CONFIG_USER_RATES } =
	PERMISSIONS.CONFIG;

const Options = () => {
	const { canI } = usePermissions();
	const { callService, isProcessing } = useService();
	const [isLoading, setIsLoading] = useState(true);
	const [options, setOptions] = useState(null);
	const { enqueueSnackbar } = useSnackbar();

	const canLoadOptions = canI(CONFIG_GENERAL.code);

	useEffect(() => {
		if (isLoading) {
			if (canLoadOptions)
				getOptions()
					.then(({ data }) => {
						setOptions(data);
						setIsLoading(false);
					})
					.catch((error) => {
						console.log(`error`, error);
						setIsLoading(false);
					});
			else setIsLoading(false);
		}
	}, [isLoading, canLoadOptions]);

	const handleSubmit = (values) => {
		callService(updateOptions(values))
			.then(({ data }) => {
				enqueueSnackbar(data?.message || 'Éxito', { variant: data.messageType });
			})
			.catch((error) => {
				console.log(`error`, error);
			});
	};

	const textOptions = (options || []).filter(({ type }) => type !== optionTypes.BOOLEAN);

	const sections = [
		{
			key: 'general',
			code: CONFIG_GENERAL.code,
			needsOptions: true,
			element: (
				<div className="Options">
					<div className="Options-list">
						<OptionsForm options={textOptions} onFinish={handleSubmit} />
					</div>
				</div>
			),
		},
		{ key: 'lists', code: CONFIG_LISTS.code, element: <UserListOptions /> },
		{ key: 'qualification', code: CONFIG_QUALIFICATION.code, element: <QualificationCriteria /> },
		{ key: 'taskTypes', code: CONFIG_TASK_TYPES.code, element: <TaskTypes /> },
		{ key: 'userRates', code: CONFIG_USER_RATES.code, element: <UserRates /> },
	]
		.filter(({ code }) => canI(code))
		.filter(({ needsOptions, element }) => !(needsOptions && isLoading) && element);

	return (
		<Layout>
			<PageTitle title="Configuración" />
			{isLoading && canLoadOptions && <Spinner text="Cargando configuración" small isOpen />}
			{isProcessing && <Spinner isOpen text="Guardando cambios" />}
			{!sections.length && !isLoading && (
				<Typography>No tienes permisos para ver ninguna sección de configuración.</Typography>
			)}
			{sections.map(({ key, element }, index) => (
				<Fragment key={key}>
					{index > 0 && <Divider style={{ margin: 16 }} />}
					{element}
				</Fragment>
			))}
		</Layout>
	);
};

export default Options;
